import {useState} from 'react'
import {MultiSelect, Option} from 'react-multi-select-component'
// import "../../../../../../style/multiSelectSucess.css"

const ListSearchSubscriptionShortlistClient = ({
  setSubscriptionShortlistClientSearch,
  selectsShortlistClient,
  setSelectsShortlistClient,
}) => {
  const initialSelectValue = [
    {value: '1', label: 'Sim'},
    {value: '0', label: 'Não'},
  ]
  const [saleShortlistClient, setSaleShortlistClient] = useState<Option[]>(initialSelectValue)

  return (
    <>
      <div className=''>
        <label className='form-label fs-6 fw-bold'>Pesquisar cliente lista outros:</label>
        <MultiSelect
          className='form-control rmscStyle'
          data-kt-user-table-filter='shortlist'
          options={saleShortlistClient}
          value={selectsShortlistClient}
          onChange={(option) => {
            const valores = option.map((item) => item.value)
            setSubscriptionShortlistClientSearch(valores)
            setSelectsShortlistClient(option)
          }}
          labelledBy={''}
          overrideStrings={{
            selectSomeItems: 'Selecione a(as) opções',
            search: 'Procurar',
            selectAll: 'Selecionar todos',
            allItemsAreSelected: 'Todos opções selecionados',
          }}
        />
      </div>
    </>
  )
}

export {ListSearchSubscriptionShortlistClient}
